import type { InfiniteScrollDirection } from 'logview/types';
import { INFINITE_SCROLL_DIRECTION_UP, INFINITE_SCROLL_DIRECTION_DOWN } from 'logview/Constants';

export const isInfiniteScrollUp = (infiniteScrollDirection: InfiniteScrollDirection) =>
  infiniteScrollDirection === INFINITE_SCROLL_DIRECTION_UP;
export const isInfiniteScrollDown = (infiniteScrollDirection: InfiniteScrollDirection) =>
  infiniteScrollDirection === INFINITE_SCROLL_DIRECTION_DOWN;
